import React from "react"
import PropTypes from "prop-types"
import Button, { ButtonBaseProps } from "@material-ui/core/ButtonBase"
import { NavLink } from "react-router-dom"
import { alpha } from "@material-ui/core/styles"
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles"
import { ButtonBase } from "@material-ui/core"

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      margin: theme.spacing(1),
      padding: theme.spacing(1),
      backgroundColor: "unset",
      "&:hover": {
        backgroundColor: alpha(theme.palette.common.black, 0.15)
      }
    },
    activeButton: {
      backgroundColor: alpha(theme.palette.common.black, 0.15),
      "&:hover": {
        backgroundColor: alpha(theme.palette.common.black, 0.25)
      }
    }
  })
)

export interface NavMenuButtonProps extends ButtonBaseProps {}

const NavMenuButton = (props: any) => {
  const classes = useStyles()
  const { children, ...others } = props
  const MyLink = React.forwardRef((props, ref) => {
    // Check if props.to includes ".pdf"
    if (props.to && props.to.includes(".pdf")) {
      // Render a regular hyperlink for PDF files
      return (
        <a href={props.to} target="_blank" rel="noopener noreferrer">
          {props.children}
        </a>
      )
    } else {
      // Render a NavLink for other links
      return <NavLink innerRef={ref} {...props} />
    }
  })

  return (
    <ButtonBase component={MyLink} className={classes.button} activeClassName={classes.activeButton} {...others}>
      {children}
    </ButtonBase>
  )
}

export default NavMenuButton
